import React from 'react'
import { Menu } from 'antd'
import {
	DownloadOutlined, DownOutlined,
	FlagOutlined,
	GlobalOutlined,
	HomeOutlined, LogoutOutlined,
	QuestionCircleOutlined, SettingOutlined,
	SketchOutlined,
	UserOutlined
} from '@ant-design/icons'
import { getState } from './redux/store'
import { MenuInfo } from 'rc-menu/lib/interface'
import { useHistory, useLocation } from 'react-router'
import { signOut } from './api/signIn'

import styles from './navbar.module.css'
import { routePathCabinet } from './pages/logined/Cabinet'

export const Navbar = (): React.ReactElement => {
	const user = getState(store => store.user)
	const history = useHistory()
	const location = useLocation()

	const handleClick = (info: MenuInfo) => {
		const key = info.key.toString()

		if (!key.startsWith('item')) {
			history.push(key)
		}
	}

	const signOutAction = async () => {
		await signOut()

		history.push('/auth')
	}

	return (
		<Menu mode="horizontal" onClick={handleClick} selectedKeys={[location.pathname]}>
			<Menu.Item icon={<HomeOutlined />}>
				<a href="https://politcubes.com" rel="noopener norefferer">
                    Главная
				</a>
			</Menu.Item>
			<Menu.Item icon={<GlobalOutlined />}>
				<a href="https://map.politcubes.com" rel="noopener norefferer">
					Онлайн карта
				</a>
			</Menu.Item>
			<Menu.Item icon={<DownloadOutlined />}>
				<a href="https://politcubes.com/downloads" rel="noopener norefferer">
					Лаунчер
				</a>
			</Menu.Item>
			<Menu.Item icon={<FlagOutlined />}>
				<a href="https://wiki.politcubes.com/general/rules" rel="noopener norefferer">
					Правила
				</a>
			</Menu.Item>
			<Menu.Item icon={<QuestionCircleOutlined />}>
				<a href="https://vk.com/topic-178448347_42701627" rel="noopener norefferer">
					F.A.Q
				</a>
			</Menu.Item>


			{
				user.nick ? (
					<Menu.SubMenu
						style={{ float: 'right' }}
						icon={<UserOutlined />}
						title={
							<>
								{user.nick}
								<DownOutlined className={styles['down-icon']}/>
							</>
						}
					>
						<Menu.Item icon={<SettingOutlined />} key={routePathCabinet}>
							Личный кабинет
						</Menu.Item>
						<Menu.Item icon={<LogoutOutlined />} onClick={signOutAction}>
							Выйти
						</Menu.Item>
					</Menu.SubMenu>
				) :
					<Menu.Item style={{ float: 'right' }} icon={<UserOutlined />} key="/auth">
						Войти в аккаунт
					</Menu.Item>
			}

			<Menu.Item style={{ float: 'right' }} icon={<SketchOutlined />} key="/donates">
				Купить донат
			</Menu.Item>
		</Menu>
	)
}
